import React from "react";

import trokitImg from "../assets/portfolio/trokit.png";
import kthimiNtshImg from "../assets/portfolio/kthimi-ntsh.png";
import thenieAppImg from "../assets/portfolio/1000-thenie.png";
import chatShqipImg from "../assets/portfolio/chat-shqip.png";
import nsShareImg from "../assets/portfolio/ns-share.png";
import kosovoElectionsPollImg from "../assets/portfolio/zgjedhjet.png";

const projects = [
  {
    img: trokitImg,
    alt: "Trokit — pamje promocionale e aplikacionit (shpallje & kërkim cimeri)",
    label: "Mobilee",
    title: "Trokit — aplikacion iOS",
    link: "https://trokit.netlify.app/",
    outcomes: [
      "Listime apartamentesh",
      "Kërkesa & bisedë në app",
      "Njoftime në kohë reale",
    ],
    body: "Aplikacion për bashkëbanim: postime, kërkesa dhe mesazhe brenda produktit — i publikuar në App Store.",
  },
  {
    img: thenieAppImg,
    alt: "1000 Thëniet Jakup Asipi — grafik promocional me kopertinë të librit",
    imgClass: "portfolio-image--contain",
    label: "Mobile",
    title: "1000 Thenie Jakup Asipi — app i dedikuar",
    outcomes: [
      "Përmbajtja e librit në app",
      "Navigim i thjeshtë",
      "Dizajn i personalizuar i markës",
    ],
    body: "Aplikacion i krijuar nga ne për librin '1000 Thenie Jakup Asipi', duke e sjellë përmbajtjen në format mobil dhe të lehtë për përdoruesit.",
  },
  {
    img: kthimiNtshImg,
    alt: "Kthimi NTSH — pamje e faqes kryesore të katalogut",
    label: "Web",
    title: "Kthimi NTSH — katalog produktesh",
    link: "https://kthimi.com/",
    outcomes: [
      "Slider hero me CTA",
      "Kategori produktesh",
      "Header i optimizuar për kontakt",
    ],
    body: "Prezencë moderne për N.T.SH KTHIMI, me fokus te produktet kryesore, navigim i qartë dhe paraqitje profesionale e biznesit.",
  },
  {
    img: nsShareImg,
    alt: "NS Share — faqe kryesore për bileta grupi NS në Holandë",
    label: "Web",
    title: "NS Share — ndarje udhëtimesh me tren në Holandë",
    outcomes: [
      "Bileta grupi NS (deri në ~40% më lirë)",
      "Gjej persona në të njëjtin drejtim",
      "Chat për koordinim para udhëtimit",
    ],
    body: "Koncept për udhëtarë në Holandë: trenat janë të shtrenjta, por me bileta zyrtare në grup mund të udhëtosh më lirë. Platforma ndihmon të lidhesh me persona që shkojnë drejt të njëjtit destinacion dhe të organizoheni së bashku — gjithmonë në përputhje me kushtet e NS.",
  },
  {
    img: chatShqipImg,
    alt: "Chat Shqip — ndërfaqe bisede në kohë reale (pamje desktop)",
    label: "Web App",
    title: "Chat Shqip — platformë mesazherike",
    link: "https://chatshqip.netlify.app/",
    outcomes: [
      "Biseda në kohë reale",
      "Autentifikim i përdoruesve",
      "Ndërfaqe moderne & responsive",
    ],
    body: "Platformë mesazherike në shqip, me komunikim në kohë reale, menaxhim bisedash dhe dizajn të pastër — e publikuar live.",
  },
  {
    img: kosovoElectionsPollImg,
    alt: "Ikona e aplikacionit iOS për sondazh zgjedhjesh në Kosovë",
    label: "Mobile",
    title: "Sondazh zgjedhjesh Kosovë — aplikacion iOS",
    outcomes: [
      "Pyetësorë për zgjedhje parlamentare & komunale",
      "Përvojë e fokusuar në iPhone",
      "Identitet vizual i lidhur me kontekstin vendor",
    ],
    body: "Aplikacion iOS për mbledhjen e opinionit dhe sondazheve rreth zgjedhjeve parlamentare dhe komunale në Kosovë — produkti është ende në punë dhe nuk është publikuar në App Store.",
  },
];

function Portfolio() {
  return (
    <section className="portfolio section-pad" id="projects">
      <div className="container">
        <div className="section-heading">
          <span className="section-tag">Punë të zgjedhura</span>
          <h2>Rezultate, jo vetëm pamje</h2>
          <p>
            Disa nga projektet tona — produkte reale, të ndërtuara për klientë realë.
          </p>
        </div>

        <div className="portfolio-grid">
          {projects.map(({ img, alt, imgClass, label, title, link, outcomes, body }) => (
            <article key={title} className="portfolio-card">
              <div className="portfolio-image-wrap">
                {imgClass === "portfolio-image--contain" && (
                  <img
                    className="portfolio-image-blur-bg"
                    src={img}
                    alt=""
                    aria-hidden="true"
                    loading="lazy"
                  />
                )}
                <img
                  className={`portfolio-image${imgClass ? ` ${imgClass}` : ""}`}
                  src={img}
                  alt={alt}
                  loading="lazy"
                />
              </div>
              <div className="portfolio-content">
                <span className="portfolio-label">{label}</span>
                <h3>{title}</h3>
                <ul className="portfolio-outcomes">
                  {outcomes.map((o) => (
                    <li key={o}>{o}</li>
                  ))}
                </ul>
                <p>{body}</p>
                {link && (
                  <a
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="portfolio-link"
                  >
                    Shiko live →
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
